import Axios from 'axios'
import { navigate } from 'gatsby'

const baseURL = `${process.env.GATSBY_CMS_URL}/wp-json`

const isBrowser = typeof window !== `undefined`

const getUser = () =>
  window.localStorage.gatsbyUser
    ? JSON.parse(window.localStorage.gatsbyUser)
    : {}

const setUser = user => (window.localStorage.gatsbyUser = JSON.stringify(user))

export const handleLogin = async ({ email, password }) => {
  if (!isBrowser) return false
  const url = `${baseURL}/jwt-auth/v1/token`
  const data = `password=${password}&username=${email}`
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
  }

  await Axios.post(url, data, config)
    .then(result => {
      const wordpress = result.data
      navigate(`/agendamento-de-visitas/convenios`)
      return setUser({
        name: wordpress.user_nicename,
        token: wordpress.token,
        email: wordpress.user_email,
      })
    })
    .catch(err => {
      return err.data.status
    })
  return false
}

export const isLoggedIn = () => {
  if (!isBrowser) return false
  const user = getUser()
  return !!user.email
}

export const getCurrentUser = () => isBrowser && getUser()

export const getUserInfo = async () => {
  const user = getCurrentUser()
  const { token } = user
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=UTF-8',
    },
  }
  const url = `${baseURL}/wp/v2/users/me?context=edit`
  const userInfo = await Axios.get(url, config)
    .then(result => {
      return result.data
    })
    .catch(err => {
      return err
    })
  return userInfo
}

export const logout = () => {
  if (!isBrowser) return
  setUser({})
  navigate(`/agendamento`)
}

export const handleSignIn = async ({ emailSignIn, passwordSignIn, nome }) => {
  if (!isBrowser) return false
  const url = `${baseURL}/wp/v2/users/register`

  const data = {
    username: emailSignIn,
    name: nome,
    email: emailSignIn,
    password: passwordSignIn,
  }
  const config = {
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
  }

  const response = await Axios.post(url, data, config)
    .then(result => {
      navigate(`/agendamento-de-visitas/convenios`)
      return result.data.code
    })
    .catch(err => {
      return err
    })
  if (response === 200) {
    alert('Cadastrado com sucesso!')
    const login = {
      email: emailSignIn,
      password: passwordSignIn,
    }
    handleLogin(login)
  }
  return false
}
